import React, { useEffect, useRef, useState } from 'react';
import { ReactNode } from 'react';
import ReactSlider from 'react-slider';

type Props = {
    range?: {
        max: number;
        min: number;
    };
    rangeLabel?: {
        max: number;
        min: number;
    };
    rangeSuffix?: string | number | ReactNode;
    value: number;
    onChange: (value: number) => any;
    onBeforeChange?: () => void;
    onAfterChange?: () => void;
    lineMultiple?: number;
};

const CustomSlider: React.FC<Props> = ({
    range = { max: 10, min: 0 },
    rangeLabel,
    rangeSuffix = '',
    value,
    onChange,
    onBeforeChange,
    onAfterChange,
    lineMultiple = 1,
}) => {
    const [lines, setLines] = useState(0);
    const sliderRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!sliderRef.current || lines || !range) return;

        const numOfLines = (range.max - range.min) * lineMultiple;

        setLines(Math.floor(numOfLines));
    }, [sliderRef, range, lineMultiple, lines]);

    return (
        <div className='slider' ref={sliderRef}>
            <div className='range'>
                <span>
                    {rangeLabel?.min ?? range.min}
                    {rangeSuffix}
                </span>
                <span>
                    {((rangeLabel?.max ?? range.max) + (rangeLabel?.min ?? range.min)) /
                        2}
                </span>
                <span>
                    {rangeLabel?.max ?? range.max}
                    {rangeSuffix}
                </span>
            </div>
            <div
                className='background'
                style={{
                    gridTemplateColumns: `repeat(${
                        (range.max - range.min) * lineMultiple || 0
                    }, 1fr)`,
                }}
            >
                {[...new Array(lines)].map((_, index) => (
                    <div key={index} className='line' />
                ))}
            </div>
            <ReactSlider
                className='horizontal-slider'
                thumbClassName='thumb'
                min={range.min}
                value={value}
                max={range.max}
                onChange={onChange}
                onBeforeChange={onBeforeChange}
                onAfterChange={onAfterChange}
                renderThumb={(props) => (
                    <div {...props}>
                        <div className='top'>
                            <div className='part-1'></div>
                            <div className='part-2'></div>
                        </div>
                        <div className='middle'></div>
                        <div className='bottom'>
                            <div className='part-1'></div>
                            <div className='part-2'></div>
                        </div>
                    </div>
                )}
            />
        </div>
    );
};

export default CustomSlider;
